// extracted by mini-css-extract-plugin
module.exports = {"Modal":"modal_Modal__22tMx"};